import script from "./PageLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageLayout.vue?vue&type=script&setup=true&lang=ts"

import "./PageLayout.vue?vue&type=style&index=0&id=3b54a222&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b54a222"]])

export default __exports__